import BaseI18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from 'locales/en/copy.json'
import zh from 'locales/zh/copy-zh_Hant_TW.json'
import id from 'locales/id/copy-id_ID.json'
import vi from 'locales/vn/copy-vi_VN.json'
import th from 'locales/th/copy-th_TH.json'

export const I18N_LOCAL_STORAGE_KEY = 'i18nextLng'

export const getLanguageCode = () => localStorage.getItem(I18N_LOCAL_STORAGE_KEY)

export const clearLanguageCode = () => {
    localStorage.removeItem(I18N_LOCAL_STORAGE_KEY)
    i18n.changeLanguage('')
}

const i18n = BaseI18n.createInstance()
i18n.use(LanguageDetector).init({
    detection: {
        order: ['localStorage', 'navigator'], // detect browser language
    },
    resources: {
        en: { translation: en },
        zh: { translation: zh },
        id: { translation: id },
        vi: { translation: vi },
        th: { translation: th },
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV !== 'production',
    keySeparator: false,
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
})

export default i18n
